module.exports = __webpack_public_path__ + "static/img/3-4.367a24a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/3-4.jpg
// module id = ZVrQ
// module chunks = 25